var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.isLoading.main)?_c('v-overlay',{attrs:{"color":"rgba(0,0,0,0.4)"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1):_vm._e(),(!_vm.isLoading.main)?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }